import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { ExchangeService } from "../../../services/api/exchange.service";
import { ExchangeActions } from "../../actions/exchange.actions";
import { FailState } from "../../models/fail-state";
import { ProposalsByProductState } from "../../models/proposal-by-product.state";
import { AppState } from "../../reducers";
import { ProposalSelectors } from "../../selectors/proposal.selectors";

@Injectable()
export class VendorProposalsByProductGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(ExchangeActions.proposalsByProduct.get),
			withLatestFrom(this.store.select(ProposalSelectors.proposalsByProduct)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(ExchangeActions.proposalsByProduct.getSuccess(state))
					: of(ExchangeActions.proposalsByProduct.getApi({ status: action.status }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(ExchangeActions.proposalsByProduct.getApi),
			switchMap((action) =>
				this.exchangeService.proposalsByProduct(action.status).pipe(
					map((proposals) =>
						ExchangeActions.proposalsByProduct.getSuccess({ proposals, loading: false })
					),
					catchError((error) =>
						of(ExchangeActions.proposalsByProduct.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private exchangeService: ExchangeService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(state: ProposalsByProductState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
